import StyledInput from '@/components/styled/StyledInput';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { EstimateFormData } from '@/types/estimates/EstimateFormData';
import { Control } from 'react-hook-form';
import { useTranslation } from '@/i18n';

interface EstimateSummaryContactCardProps {
  control: Control<EstimateFormData>;
  isViewMode?: boolean;
}

const EstimateSummaryContactCard = ({
  control,
  isViewMode = false,
}: EstimateSummaryContactCardProps) => {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('estimates.details.contact.title')}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4 w-full">
        <div className="flex flex-col md:flex-row gap-4">
          <StyledInput
            control={control}
            name="mainContact.lastName"
            title={t('estimates.details.contact.lastName')}
            placeholder={t('estimates.details.contact.lastName')}
            disabled={isViewMode}
          />
          <StyledInput
            control={control}
            name="mainContact.firstName"
            title={t('estimates.details.contact.firstName')}
            placeholder={t('estimates.details.contact.firstName')}
            disabled={isViewMode}
          />
        </div>
        {/* <div className="flex flex-col md:flex-row gap-4">
          <StyledInput
            control={control}
            name="mainContact.email"
            title={t('estimates.details.contact.email')}
            type="email"
            placeholder={t('estimates.details.contact.email')}
            disabled={isViewMode}
          />
          <StyledInput
            control={control}
            name="mainContact.phoneNumber"
            title={t('estimates.details.contact.phone')}
            type="tel"
            placeholder={t('estimates.details.contact.phone')}
            disabled={isViewMode}
          />
        </div>
        <StyledInput
          control={control}
          name="mainContact.address"
          title={t('estimates.details.contact.address')}
          placeholder={t('estimates.details.contact.address')}
          disabled={isViewMode}
        />
        <div className="flex flex-col md:flex-row gap-4">
          <StyledInput
            control={control}
            name="mainContact.postalCode"
            title={t('estimates.details.contact.postalCode')}
            placeholder={t('estimates.details.contact.postalCode')}
            disabled={isViewMode}
          />
          <StyledInput
            control={control}
            name="mainContact.city"
            title={t('estimates.details.contact.city')}
            placeholder={t('estimates.details.contact.city')}
            disabled={isViewMode}
          />
        </div> */}
      </CardContent>
    </Card>
  );
};

export default EstimateSummaryContactCard;
